/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable arrow-parens */
/* eslint-disable prettier/prettier */
/* eslint-disable consistent-return */
import styled, { css } from 'styled-components';

interface GridProps {
  small: string;
  medium: string;
  large: string;
}

interface IconContainerProps {
  align?: 'center' | 'init';
}

const IconContainerVariations = {
  center: css`
    justify-content: center;
  `,
  init: css`
    justify-content: flex-start;
  `,
};

export const Row = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  &:before,
  &after {
    content: '';
    display: table;
  }
  &:after {
    clear: both;
  }
`;

function getWidthGrid(value: string) {
  if (!value) return;
  const width = (Number(value) / 12) * 100;
  return `width: ${width}%`;
}

export const Column = styled.div<GridProps>`
  width: 100%;
  padding: 0.25rem;
  min-height: 1px;
  box-sizing: border-box;
  margin-bottom: 25px;

  @media only screen and (min-width: 768px) {
    ${props => props.small && getWidthGrid(props.small)};
  }

  @media only screen and (min-width: 1024px) {
    ${props => props.medium && getWidthGrid(props.medium)};
  }

  @media only screen and (min-width: 1440px) {
    ${props => props.large && getWidthGrid(props.large)};
  }
`;

export const InfoContainer = styled.div`
  .title {
    color: var(--red) !important;
    margin-bottom: 10px;
    margin-left: 5px;
  }
`;

export const InfoItem = styled.div`
  color: var(--orange);
  margin-bottom: 10px;
  min-height: 66px;
  border-radius: 18px;
  border: 1px solid var(--orange);
  padding: 10px;
  font-size: 0.8rem;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 15px;
  }

  .info {
  display: flex;
  align-self: stretch;

    font-size: 1.3rem;
    margin-right: 10px;
    @media only screen and (max-width: 1200px) {
      margin-right: 0px;
      margin-bottom: 5px;
    }
    @media only screen and (max-width: 768px) {
      margin-right: 10px;
      margin-top: 3px;
    }
  }

  .ajuda {
    p + p {
      margin-top: 10px;
    }
 
  }

  .info-subtitle {
    color: var(--purple) !important;
    margin-top: 3px;
  }

  .text {
    color: var(--red) !important
  }


  a {
    font-weight: bold;
  }

  @media only screen and (max-width: 1200px) {
   flex-wrap: wrap;
   padding: 5px 15px 5px 20px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 110px;
  }
}
`;

export const IconContainer = styled.div<IconContainerProps>`
  color: var(--orange);
  font-size: 112px;
  display: flex;
  align-items: center;

  ${props =>
    props.align === 'center'
      ? IconContainerVariations.center
      : IconContainerVariations.init}

  svg {
    width: 110px;
  }
`;
